import { render, staticRenderFns } from "./IrisNotification.vue?vue&type=template&id=301ef5db&"
import script from "./IrisNotification.vue?vue&type=script&lang=ts&"
export * from "./IrisNotification.vue?vue&type=script&lang=ts&"
import style0 from "./IrisNotification.vue?vue&type=style&index=0&id=301ef5db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports